import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-modal-alert',
  templateUrl: './modal-alert.component.html',
  styleUrls: ['./modal-alert.component.scss']
})
export class ModalAlertComponent implements OnInit {
  icon: any
  title: any
  content: any
  btnAction0: any
  btnAction1: any
  btnAction2: any
  idBtnAction0: any
  idBtnAction1: any
  idBtnAction2: any
  templateSuffix = environment.templateSuffix;
  constructor(
    private dialogRef: MatDialogRef<ModalAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon(
      "info-custom", this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/alerts/info-custom.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "check-custom", this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/alerts/check-custom.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "error-custom", this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/alerts/error-custom.svg")
    );
  }

  ngOnInit(): void {
    this.icon = this.data.icon;
    this.title = this.data.title;
    this.content = this.data.content;
    this.btnAction0 = this.data.btnAction0;
    this.btnAction1 = this.data.btnAction1;
    this.btnAction2 = this.data.btnAction2;
    this.idBtnAction0 = this.data.idBtnAction0;
    this.idBtnAction1 = this.data.idBtnAction1;
    this.idBtnAction2 = this.data.idBtnAction2;
  }

  getJustify(){
    return (this.btnAction1 && this.btnAction2) || (this.btnAction0 && this.btnAction2) ? 'btns-space' : 'btns-center';
  }

}
